<template>
    
    <span>
        <div id="card-element" ref="card-element"></div>
    </span>

</template>

<script>

import LocalStripeService from '../services/LocalStripeService';

export default {
    name: "StripeField",
    components: {},
    mixins: [],
    props: {
        parentId: {
            type: String,
            default: 'credit-info'
        }
    }, 
    data() {
        return {
            stripeData: {
                stripe: null,
                apiToken: process.env.VUE_APP_ENV_STRIPE_API_TOKEN || 'VUE_APP_ENV_STRIPE_API_TOKEN not set',
                card: null,
                elements: null,
                stripeStyle: {
                    base: {
                        color: "#32325d",
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: "antialiased",
                        fontSize: "16px",
                        "::placeholder": {
                            color: "#aab7c4"
                        }
                    },
                        invalid: {
                        color: "#fa755a",
                        iconColor: "#fa755a"
                    }
                }
            },
            stripeDataValidation: {
                cardError: null,
                cardMessage: null
            }
        }
    },
    created() {
        
        this.$root.$on('bv::collapse::state', (id, state) => {

            if(id == this.parentId && state) {
                this.configureStripe();
            }
        })
    },
    mounted() {

        //console.log('StripeField.mounted()')

        this.includeStripe('js.stripe.com/v3/', function() {
            this.configureStripe();
        }.bind(this) );
    },
    methods: {
        configureStripe(){
            
            try {
                
                if(typeof this.stripeData.stripe == 'undefined' || this.stripeData.stripe === null) {
                    this.stripeData.stripe = Stripe( this.stripeData.apiToken );    
                }
    
                this.stripeData.elements = this.stripeData.stripe.elements();
                this.stripeData.card = this.stripeData.elements.create('card', {
                    classes: {
                        base: 'form-control'
                    }
                });
    
                this.stripeData.card.mount('#card-element');
    
                let that = this
                this.stripeData.card.addEventListener('change', this.handleStripeError)
            
            } catch(e) {
                //console.log('Stripe not configured: ')
                //console.log(e)
            }
            
            

        },
        createNewStripePaymentMethod(customerId) {
            
            //console.log('ProfileForm.createNewStripePaymentMethod starting')
            
            let that = this

            return this.stripeData.stripe.createPaymentMethod({
                type: 'card',
                card: this.stripeData.card
            }).then((result) => {
            
                //console.log(result)
                
                if(result.error) {
                    
                    throw result.error
                
                } else {

                    let attachData = {
                        paymentMethodId: result.paymentMethod.id,
                        customerId: customerId
                    }
                    
                    return LocalStripeService.attachPaymentMethod(attachData, this.$store.getters.getUserToken).then((response) => {
                
                        //console.log('StripeField.createNewStripePaymentMethod: Response from attachPaymentMethod = ' + JSON.stringify(response))
                        
                        return response
                    
                    }).then((result) => {
                        
                        // result.customer.id is used to map back to the customer object
                        // result.setupIntent.client_secret is used to create the payment method
                        
                        //console.log('StripeField.createNewStripePaymentMethod: result = ' + JSON.stringify(result))

                        //console.log(JSON.stringify(result.data.result.data))
                        
                        if(result.data.result.successful) {
                            return result.data.result.data
                        } else {
                            throw result.data.result.message
                        }

                        
                    
                    })
                    
                    

                }
            })
            .then(this.handleStripePaymentMethodComplete)
            .catch((error) => {
                
                //console.log('ProfileForm.createStripePaymentMethod encountered exception: ')
                //console.log(error)

                this.handleStripeError({error: error})
            
            })
        },
        createStripeCustomer(nameFirst, nameLast, addressEmail) {
            
            //console.log('StripeDemo.createStripeCustomer STARTED')

            let customer = {
                name: nameFirst + ' ' + nameLast,
                description: 'Principal Task Customer',
                email: addressEmail
            }
            
            return LocalStripeService.createCustomer(customer, this.$store.getters.getUserToken).then((response) => {
                
                //console.log('StripeDemo.createStripeCustomer: Response from createCustomer = ' + JSON.stringify(response))
                
                return response
            
            }).then(result => {
                
                // result.customer.id is used to map back to the customer object
                // result.setupIntent.client_secret is used to create the payment method
                
                //console.log('StripeDemo.createStripeCustomer: result = ' + JSON.stringify(result))
                
                return result
            
            })
        },
        createStripePaymentMethod(customerId, priceId) {
            
            // 20200606 -- ZWS -- Creates a PaymentMethod and displays an error
            // or invokes createStripeSubscription to subscribe the customer.

            //console.log('ProfileForm.createStripePaymentMethod starting')
            
            let that = this

            return this.stripeData.stripe.createPaymentMethod({
                type: 'card',
                card: this.stripeData.card
            }).then((result) => {
            
                if(result.error) {
                    
                    throw result.error
                
                } else {

                    //console.log('StripDemo.createStripePaymentMethod result: ' + JSON.stringify(result))
                    
                    let subscription = {
                        customerId: customerId,
                        paymentMethodId: result.paymentMethod.id,
                        priceId: priceId || 'UNKNOWN'
                    }

                    //console.log('StripeDemo.createStripePaymentMethod creating subscription = ' + JSON.stringify(subscription))
                    
                    this.createStripeSubscription(subscription)

                }
            }).catch((error) => {
                
                //console.log('ProfileForm.createStripePaymentMethod encountered exception: ')
                //console.log(error)

                error.showToast = true
                
                this.handleStripeError({error: error})

                // this.$refs.resetButton.disabled = false
                // this.$refs.submitButton.disabled = false
            
            })
        },
        async createStripeSubscription({customerId, paymentMethodId, priceId}) {

            //console.log('ProfileForm.createStripeSubscription starting')
            
            let subscription = {
                customer: customerId,
                default_payment_method: paymentMethodId,
                priceId: priceId
            }

            return LocalStripeService.subscribeCustomer(subscription, this.$store.getters.getUserToken).then((response) => {
            
                console.log('LocalStripeService.subscribeCustomer returned '+ JSON.stringify(response))
                
                return response

            }).then((result) => {

                if (!result.data.result.successful) {
                
                    console.log('Encountered an error: ' + JSON.stringify(result.data.result))
                    
                    // 20200611 -- ZWS -- Why the raw?
                    //throw {error: result.data.result.data.raw}
                    
                    throw {error: result.data.result, showToast: true}
                
                } else {

                    console.log('Customer Subscribed according to initial check.')

                }

                return result;

            }).then((result) => {

                return {
                    paymentMethodId: paymentMethodId,
                    priceId: priceId,
                    subscription: result.data.result.data,
                };

            })
            .then(this.handleStripeCustomerActionRequired)
            .then(this.handleStripeSubscriptionComplete)
            .catch((error) => {
                
                console.log('ProfileForm.createStripeSubscription encountered an exception: ' + JSON.stringify(error))
                
                this.handleStripeError(error)
            
            })

        },
        handleStripeCustomerActionRequired({subscription, invoice, priceId, paymentMethodId, isRetry}) {

            console.log('ProfileForm.handleStripeCustomerActionRequired Started')
            console.log('subscription = ' + JSON.stringify(subscription))
            console.log('invoice = ' + invoice)
            console.log('priceId = ' + priceId)
            console.log('paymentMethodId = ' + paymentMethodId)
            console.log('isRetry = ' + isRetry)
            
            if(subscription && subscription.status === 'active') {
                console.log('ProfileForm.handleStripeCustomerActionRequired: Finished, no further action required.')
                return {subscription, priceId, paymentMethodId}
            }

            let paymentIntent = invoice ? invoice.payment_intent : subscription.latest_invoice.payment_intent

            if(paymentIntent.status === 'requires_action' ||
            (isRetry === true && paymentIntent.status === 'requires_payment_method')) {

                return this.stripeData.stripe.confirmCardPayment(paymentIntent.client_secret, {
                    payment_method: paymentMethodId
                }).then((result) => {
                    
                    console.log('ProfileForm.handleStripeCustomerActionRequired has action result = ' + JSON.stringify(result))
                    
                    if(result.error) {
                        
                        console.log(JSON.stringify(result.error))
                        
                        throw result
                    
                    } else {
                        if(result.paymentIntent.status === 'succeeded') {
                            
                            // 20200607 -- ZWS -- Update payment intent with
                            // data returned from the user's additional
                            // action.  This feels wrong...
                            subscription.latest_invoice.payment_intent = result.paymentIntent

                            this.$set(this.stripeDataValidation, 'cardError', true)
                            this.$set(this.stripeDataValidation, 'cardMessage', '')
                            
                            return {
                                
                                subscription: subscription,
                                priceId: priceId,
                                paymentMethodId: paymentMethodId
                            }
                        }
                    }
                }).catch((error) => {
                    
                    error.showToast = true
                    throw error
                })

            } else {
                return {subscription, priceId, paymentMethodId}
            }

        },
        handleStripeError(event) {
                
            //console.log('stripe.handleStripError invoked with event = ')
            //console.log(event)

            try {
                
                if (event.error) {
                    //console.log('listener encountered error = ' + JSON.stringify(event))
                    //console.log('listener setting error message = ' + event.error.message)

                    this.$set(this.stripeDataValidation, 'cardError', false)
                    this.$set(this.stripeDataValidation, 'cardMessage', event.error.message)
                } else {
                    //console.log('listener encounterd OK')

                    this.$set(this.stripeDataValidation, 'cardError', true)
                    this.$set(this.stripeDataValidation, 'cardMessage', '')
                }   
                
                this.$emit('statusUpdate:StripeField', {cardError: this.stripeDataValidation.cardError,
                    cardMessage: this.stripeDataValidation.cardMessage, showToast: event.showToast})

            } catch(e) {
                //console.log('Error in handleStripeError: ')
                //console.log(e)
            }
            
        },
        handleStripePaymentMethodComplete(data) {
            this.$emit('newPaymentMethod:StripeField', data)
        },
        handleStripeSubscriptionComplete({subscription, priceId, paymentMethodId}) {

            console.log('ProfileForm.handleStripeSubscriptionComplete Started')
            console.log('subscription = ' + JSON.stringify(subscription))
            console.log('priceId = ' + priceId)
            console.log('paymentMethodId = ' + paymentMethodId)
            
            // 20200607 -- ZWS -- Basing the decision on the form validation.
            // Form validation is reversed: false means there's a problem.

            if(this.stripeDataValidation.cardError && !this.stripeDataValidation.cardError) {
                console.log('card remains in error.  Not activating account.')
                this.makeToast(true, 'Subscription Status', 'Unable to create your account: unknown error.', 'danger')
                return {subscription, priceId, paymentMethodId}
            }
            
            // Check if subscription is already active (no payment needed)
            if (subscription && subscription.status === 'active') {
                console.log('Subscription is active')
                
                let data = {
                    productId: subscription.plan.product,
                    subscriptionId: subscription.id,
                    customerId: subscription.customer,
                    paymentDetails: {
                        invoiceUrl: subscription.latest_invoice ? subscription.latest_invoice.hosted_invoice_url : null,
                        priceId: priceId
                    }
                }

                this.$emit('newSubscription:StripeField', data)
                return
            }
            
            let paymentStatus = null
            
            try {
                paymentStatus = subscription.latest_invoice.payment_intent.status
            } catch(e) {
                console.log('Error setting payment status:')
                console.log(e)
            }

            console.log('paymentStatus = ' + paymentStatus)

            if(paymentStatus === 'succeeded') {
                
                //console.log('Success!')
                
                let data = {
                    productId: subscription.plan.product,
                    subscriptionId: subscription.id,
                    customerId: subscription.customer,
                    paymentDetails: {
                        invoiceUrl: subscription.latest_invoice.hosted_invoice_url,
                        priceId: priceId
                    }
                }

                this.$emit('newSubscription:StripeField', data)

                // this.makeToast(true, 'Subscription Status', 'Your account was created successfully.', 'success')

                

            } else {

                throw {error: {message: 'Unknown error encountered while subscribing.  Please contact support.'}}

                // this.$refs.resetButton.disabled = false
                // this.$refs.submitButton.disabled = false

            }
            

        },
        includeStripe( URL, callback ){
            let documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },

    }
}
</script>

<style>

</style>